import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const MobileBookmarkBanner = () => {
  const [bannerSettings, setBannerSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('🚀 MobileBookmarkBanner mounted - starting fetch');
    fetchBannerSettings();
  }, []);

  const fetchBannerSettings = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/banner-settings`);
      console.log('📱 Banner settings fetched:', response.data);
      setBannerSettings(response.data);
    } catch (error) {
      console.error('❌ Error fetching banner settings:', error);
      // Set default settings on error
      const defaults = {
        enabled: true,
        ios_image_url: "https://customer-assets.emergentagent.com/job_shoot-log-dash/artifacts/p9j6jxok_1.png",
        ios_link: "https://vimeo.com/1129510748",
        android_image_url: "https://customer-assets.emergentagent.com/job_shoot-log-dash/artifacts/effh6l01_2.png",
        android_link: "https://vimeo.com/1129510730"
      };
      console.log('📱 Using default banner settings:', defaults);
      setBannerSettings(defaults);
    } finally {
      setLoading(false);
    }
  };

  // Don't render if disabled or loading
  if (loading) {
    console.log('📱 Banner loading...');
    return (
      <div className="mt-8 mb-0 p-4 bg-gray-800 rounded text-center text-gray-400">
        Laster bannere...
      </div>
    );
  }
  
  if (!bannerSettings) {
    console.log('❌ No banner settings available');
    return (
      <div className="mt-8 mb-0 p-4 bg-red-900/20 rounded text-center text-red-400">
        ⚠️ Kunne ikke laste banner-innstillinger
      </div>
    );
  }
  
  if (!bannerSettings.enabled) {
    console.log('📱 Banners are disabled');
    return (
      <div className="mt-8 mb-0 p-4 bg-yellow-900/20 rounded text-center text-yellow-400">
        ℹ️ Bannere er deaktivert
      </div>
    );
  }
  
  console.log('✅ Rendering banners:', bannerSettings);

  return (
    <div className="mt-8 mb-0">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
        {/* iOS Banner */}
        {bannerSettings.ios_image_url && bannerSettings.ios_link && (
          <a
            href={bannerSettings.ios_link}
            target="_blank"
            rel="noopener noreferrer"
            className="block group relative overflow-hidden transition-all duration-300 hover:opacity-90"
          >
            <img
              src={bannerSettings.ios_image_url}
              alt="Legg til Aktivlogg på iOS hjemskjermen"
              className="w-full h-auto object-cover"
            />
          </a>
        )}

        {/* Android Banner */}
        {bannerSettings.android_image_url && bannerSettings.android_link && (
          <a
            href={bannerSettings.android_link}
            target="_blank"
            rel="noopener noreferrer"
            className="block group relative overflow-hidden transition-all duration-300 hover:opacity-90"
          >
            <img
              src={bannerSettings.android_image_url}
              alt="Legg til Aktivlogg på Android hjemskjermen"
              className="w-full h-auto object-cover"
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default MobileBookmarkBanner;
